import { useState, useEffect } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import Button from '../../Button';

const PortsOfCall = ({ itineraryPortsOfCall, defaultDoShowAllPorts = false }) => {
  const doShowAllPortsButton = !defaultDoShowAllPorts;
  const originalPortsOfCallArray = itineraryPortsOfCall && itineraryPortsOfCall.split(',');
  const limit = defaultDoShowAllPorts && originalPortsOfCallArray
    ? originalPortsOfCallArray.length : 4;
  const [doShowAllPorts, setDoShowAllPorts] = useState(defaultDoShowAllPorts);
  const [portsOfCallArray, setPortsOfCallArray] = useState(originalPortsOfCallArray
    && originalPortsOfCallArray.slice(0, limit));

  const handleToggleAllPortsClick = () => {
    setDoShowAllPorts((v) => !v);
  };

  useEffect(() => {
    setPortsOfCallArray(originalPortsOfCallArray && originalPortsOfCallArray.slice(0, doShowAllPorts
      ? originalPortsOfCallArray.length
      : limit));
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [doShowAllPorts]);

  return (
    portsOfCallArray && portsOfCallArray.map((port, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <span key={port + index}>
        {port}
        {' '}
        {index < portsOfCallArray.length - 1
          && <span>&rarr;&nbsp;</span>}
        {doShowAllPortsButton
          && index >= portsOfCallArray.length - 1 && originalPortsOfCallArray.length > limit
          && (
            <span>
              {!doShowAllPorts && <span>... &nbsp;</span>}
              <br />
              <Button variant={Button.buttonVariants.LINK} onClick={handleToggleAllPortsClick}>
                <span>
                  {doShowAllPorts ? 'Hide' : 'Show'}
                  {' '}
                  all ports
                  {!doShowAllPorts && <FaChevronDown className="inline-block h-3" />}
                  {doShowAllPorts && <FaChevronUp className="inline-block h-3" />}
                </span>
              </Button>
            </span>
          )}
      </span>
    ))
  );
};

export default PortsOfCall;
